import { MetaTag } from "../../pages/[...slug]";
import { ProductResponse } from "../modules/details/models/detail-page";
import { API } from "./api-services";

// interface VideoObject {
//   name: string;
//   duration: number;
//   uploadDate: string;
//   thumbnailUrl: string;
//   description: string;
//   contentUrl: string;
// }

interface Organization {
  "@type": string;
  name: string;
  url: string;
  alternateName: string;
  logo: {
    "@type": string;
    url: string;
  };
  sameAs: string[];
}

interface ListItem {
  "@type": string;
  position: number;
  url: string;
}

interface ItemList {
  "@type": string;
  url: string;
  itemListElement: ListItem[];
}

interface ImageObject {
  "@type": string;
  url: string;
}

interface VideoObject {
  "@type": string;
  name: string;
  duration: string;
  description: string;
  thumbnailUrl: string;
  contentUrl?: string;
  uploadDate: string;
  publisher?: string;
}

interface AggregateRating {
  "@type": string;
  bestRating: number;
  ratingValue: number;
}

interface Person {
  "@type": string;
  name: string;
}

interface InteractionCounter {
  "@type": string;
  interactionType: string;
  userInteractionCount: string;
}

interface Movie {
  "@type": string;
  actor: any[];
  name: string;
  description: string;
  image: ImageObject;
  dateCreated: string;
  // trailer: VideoObject;
  aggregateRating: AggregateRating;
  director?: Person;
  interactionStatistic?: InteractionCounter;
}

interface TVEpisode {
  "@type": string;
  position: number;
  url: string;
}

interface TVSeason {
  "@type": string;
  name: string;
  description: string;
  image: string;
  episode: TVEpisode;
}

interface TVSeries {
  "@type": string;
  name: string;
  actor: any[];
  aggregateRating: AggregateRating;
  containsSeason: TVSeason;
}

interface ItemListLD {
  url: string;
  itemListUrl: string[];
}

interface BreadCrumbListItem {
  name: string;
  url: string;
}

interface FAQ {
  question: string;
  answer: string;
}

interface ArticleObject extends ProductResponse {
  url: string;
}

const regionsAllowed =
  "AD,AE,AF,AG,AI,AL,AM,AO,AQ,AR,AS,AT,AU,AW,AX,AZ,BA,BB,BD,BE,BF,BG,BH,BI,BJ,BL,BM,BN,BO,BQ,BR,BS,BT,BV,BW,BY,BZ,CA,CC,CD,CF,CG,CH,CI,CK,CL,CM,CN,CO,CR,CU,CV,CW,CX,CY,CZ,DE,DJ,DK,DM,DO,DZ,EC,EE,EG,EH,ER,ES,ET,FI,FJ,FK,FM,FO,FR,GA,GB,GD,GE,GF,GG,GH,GI,GL,GM,GN,GP,GQ,GR,GS,GT,GU,GW,GY,HK,HM,HN,HR,HT,HU,ID,IE,IL,IM,IN,IO,IQ,IR,IS,IT,JE,JM,JO,JP,KE,KG,KH,KI,KM,KN,KP,KR,KW,KY,KZ,LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MH,MK,ML,MM,MN,MO,MP,MQ,MR,MS,MT,MU,MV,MW,MX,MY,MZ,NA,NC,NE,NF,NG,NI,NL,NO,NP,NR,NU,NZ,OM,PA,PE,PF,PG,PH,PK,PL,PM,PN,PR,PS,PT,PW,PY,QA,RE,RO,RS,RU,RW,SA,SB,SC,SD,SE,SG,SH,SI,SJ,SK,SL,SM,SN,SO,SR,SS,ST,SV,SX,SY,SZ,TC,TD,TF,TG,TH,TJ,TK,TL,TM,TN,TO,TR,TT,TV,TW,TZ,UA,UG,UM,US,UY,UZ,VA,VC,VE,VG,VI,VN,VU,WF,WS,YE,YT,ZA,ZM,ZW";

function getISODuration(durationInSeconds: number) {
  const duration = new Date(0);
  duration.setSeconds(durationInSeconds);
  const Hours = duration.getUTCHours() > 0 ? duration.getUTCHours() + "H" : "";
  const Minutes =
    duration.getUTCMinutes() > 0 ? duration.getUTCMinutes() + "M" : "";
  const Seconds =
    duration.getUTCSeconds() > 0 ? duration.getUTCSeconds() + "S" : "";

  const isoDuration = "PT" + Hours + Minutes + Seconds;

  return isoDuration;
}

function buildOrganization() {
  return {
    "@type": "Organization",
    name: "دیجیتون",
    url: "http://www.digitoon.tv",
    alternateName: "Digitoon",
    logo: {
      "@type": "ImageObject",
      url: "https://www.digitoon.tv/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Flogo.6c609670.png&w=256&q=75"
    },
    sameAs: [
      "https://twitter.com/digitoon_tv",
      "https://www.instagram.com/digitoon.ir/",
      "https://www.youtube.com/channel/UCYqqHS3eR2rnfWf5jHbOktw",
      "https://www.linkedin.com/company/digitoon-tv",
      "https://fa.wikipedia.org/wiki/%D8%AF%DB%8C%D8%AC%DB%8C%D8%AA%D9%88%D9%86"
    ]
  };
}

function buildItemList(data: MetaTag | any) {
  const itemListElements = data?.itemListUrl.map((url: string, i: number) => ({
    "@type": "ListItem",
    position: i + 1,
    url: url
  }));

  return {
    "@type": "ItemList",
    url: data?.url,
    itemListElement: itemListElements
  };
}

function buildMovie(data: MetaTag | any) {
  const description = data?.description.replace(/"/g, "");
  const trailerDuration = getISODuration(data?.videoDuration);

  return {
    "@type": "Movie",
    actor: [],
    name: data?.title,
    description: description,
    image: {
      "@type": "ImageObject",
      url: data?.avatar
    },
    dateCreated: data?.datePublished,
    // trailer: {
    //   "@type": "VideoObject",
    //   name: data?.title,
    //   description: description,
    //   thumbnailUrl: data?.thumbnailUrl,
    //   duration: trailerDuration,
    //   // contentUrl: data?.url,
    //   uploadDate: data?.datePublished
    // },
    aggregateRating: {
      "@type": "AggregateRating",
      bestRating: 5,
      ratingValue: data?.rank
    },
    // director: {
    //   "@type": "person",
    //   name: ""
    // },
    // interactionStatistic: {
    //   "@type": "InteractionCounter",
    //   interactionType: "https://schema.org/CommentAction",
    //   userInteractionCount: ""
    // }
  };
}

function buildVideo(data: MetaTag | any) {
  const description = data?.description.replace(/"/g, "");
  const videoDuration = getISODuration(data?.videoDuration);

  return {
    "@type": "VideoObject",
    name: data?.title,
    duration: videoDuration,
    description: description,
    thumbnailUrl: data?.thumbnailUrl,
    contentUrl: data?.videoLink,
    uploadDate: data?.datePublished,
    publisher: "digitoon"
  };
}

function buildTVSeries(data: MetaTag) {
  const description = data?.description.replace(/"/g, "");

  return {
    "@type": "TVSeries",
    name: data?.title,
    actor: [],
    aggregateRating: {
      "@type": "AggregateRating",
      bestRating: 5,
      ratingValue: data?.rank
    },
    containsSeason: {
      "@type": "TVSeason",
      name: data?.title,
      description: description,
      image: data?.avatar,
      episode: {
        "@type": "TVEpisode",
        position: data?.seriesPosition,
        url: data?.url
      }
    }
  };
}

type BuilderFunction = (
  data: any
) => Organization | ItemList | Movie | VideoObject | TVSeries | null;

type BuilderFunctions = Array<BuilderFunction>;

function buildJsonLd(data: any, builderFunctions: BuilderFunctions) {
  const graph = [];

  for (const builder of builderFunctions) {
    const result = builder(data);
    if (result) {
      graph.push(result);
    }
  }

  return JSON.stringify({
    "@context": "http://schema.org",
    "@graph": graph
  });
}

export function addMovieJsonLd(data: MetaTag) {
  return {
    __html: buildJsonLd(data, [
      buildOrganization,
      // buildItemList,
      buildMovie,
      buildVideo
    ])
  };
}

export function addSeriesJsonLd(data: MetaTag) {
  return {
    __html: buildJsonLd(data, [
      buildOrganization,
      // buildItemList,
      buildMovie,
      buildVideo,
      buildTVSeries
    ])
  };
}

export function addCategoryJsonLd(data: any) {
  
  return {
    __html: buildJsonLd(data, [
      buildOrganization,
      buildItemList,
    ])
  };
}

export function addWebsiteJsonLd() {
  return {
    __html: `{
      "@context": "https://schema.org/",
      "@type": "WebSite",
      "url": "${API.site()}",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://www.digitoon.tv/search?catId=0&keyword={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }
  `
  };
}

export function addOrganizationJsonLd() {
  return {
    __html: `{
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "دیجیتون",
      "alternateName": "Digitoon",
      "url": "${API.site()}",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.digitoon.tv/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Flogo.6c609670.png&w=256&q=75"
      },
      "sameAs": [
        "https://twitter.com/digitoon_tv",
        "https://www.instagram.com/digitoon.ir/",
        "https://www.youtube.com/channel/UCYqqHS3eR2rnfWf5jHbOktw",
        "https://www.linkedin.com/company/digitoon-tv",
        "https://fa.wikipedia.org/wiki/%D8%AF%DB%8C%D8%AC%DB%8C%D8%AA%D9%88%D9%86"
      ]
    }`
  };
  
}

export function addItemListJsonLd(data: ItemListLD) {
  return {
    __html: `{
        "@context": "https://schema.org/",
        "@type": "ItemList",
        "url": "${data.url}",
        "itemListElement": [
            ${data.itemListUrl.map((url, i) => {
              return `{ 
                  "@type": "ListItem",
                  "position": "${i + 1}",
                  "url": "${url}"
                      }`;
            })}
            
        ]
      }`
  };
}

export function addBreadcrumbJsonLd(data: BreadCrumbListItem[]) {
  return {
    __html: `{
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          "itemListElement": [
              ${data.map((item, i) => {
                return `{ 
                    "@type": "ListItem",
                    "position": "${i + 1}",
                    "name": "${item.name}",
                    "item": "${item.url}"
                  }`;
              })}  
          ]
        }`
  };
}

export function addArticleJsonLd(article: ArticleObject) {
  return {
    __html: `{
      "@context": "https://schema.org/",
      "@type": "Article",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "${article.url}"
      },
      "headline": "${article.name}",
      "description": "${article.short_description.replace(/"/g, "")}",
      "image": {
        "@type":  "ImageObject",
        "url": "${article.feature_avatar.mdpi}",
        "width": "480px",
        "height": "300px"
      },
      "author": {
        "@type": "Person",
        "name": " دیجیتون مگ "
      },
      "publisher": {
        "@type": "Organization",
        "name": "دیجیتون مگ",
        "logo": {
          "@type": "ImageObject",
          "url": "https://media.digitoon.ir/8/themes/digitoon-magFocyQKqJx7_1681050646.jpg",
          "width": "358px",
          "height": "96px"
        }
      },
      "datePublished": "${article.date_published}",
      "dateModified": "${article.date_published}"
    }
  `
  };
}

export function addFAQJsonLd(data: FAQ[]) {
  return {
    __html: `{
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            "mainEntity": [
                ${data.map((item, i) => {
                  return `{ 
                      "@type": "Question",
                      "name": "${item.question}",
                      "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "${item.answer}"
                      }
                    }`;
                })}
                
            ],
          }`
  };
}

export const breadCrumbDownloadAppData = [
  {
    name: "خانه",
    url: API.site()
  },
  {
    name: "دانلود اپلیکیشن دیجیتون",
    url: `${API.site()}contact/download-applications`
  }
];

export const breadCrumbSubscriptionData = [
  {
    name: "خانه",
    url: API.site()
  },
  {
    name: "خرید اشتراک دیجیتون",
    url: `${API.site()}subscription`
  }
];

export const FAQSubscriptionAppData: FAQ[] = [
  {
    question: "چرا باید اشتراک بخریم؟",
    answer:
      "حق اشتراکی که شما پرداخت می کنید بابت خدمات زیر می باشد:-  انیمیشن های دیجیتون در استدیو دیجیتون دوبله می شوند.-  محتوای انیمیشن ها متناسب با رده بندی سنی کودکان آماده سازی می شوند.-  تولید محتواهایی مانند انیمیشن، بازی، قصه، کتاب صوتی، موزیکال و محتوای آموزشی به صورت اختصاصی در دیجیتون صورت گرفته و در اختیار کاربران قرار می گیرد.-  امکانات کنترلی برای والدین از جمله: اعمال رده بندی سنی، اعمال محدودیت در مدت زمان استفاده و قفل تک محتوا به علاوه ارائه گزارش استفاده کودک از دیجیتون و امکانات دیگر-  امکان استفاده از اینترنت رایگان برای اپراتورهای منتخب (برای دریافت اطلاعات بیشتر به سایت دیجیتون مراجعه کنید) *. در دیجیتون انیمیشن های رایگان هم وجود دارد که شما میتونید از دسته بندی ها گزینه رایگان رو انتخاب کنید"
  },
  {
    question: "نحوه خرید اشتراک",
    answer: `رای خرید اشتراک قبل از هرکاری، ابتدا باید در دیجیتون ثبت‌نام کنید اگر از قبل ثبت‌نام کرده‌اید ، ابتدا وارد حساب کاربری خود شوید. 
    شما می‌توانید برای خرید اشتراک از دو طریق وب سایت یا اپلیکیشن دیجیتون اقدام کنید کافیست روی خرید و یا تمدید اشتراک بزنید،
    وارد صفحه اشتراک‌ها می‌شود در آن‌جا از میان بسته‌های پیشنهاد شده، بسته مناسب خود را انتخاب میکینید،
    بعد از انتخاب بسته می‌توانید از طریق هر کارت بانکی‌ که به سیستم شتاب وصل است به صورت آنلاین خرید خود را انجام دهید.`
  },
  {
    question: "چطور می توانم اشتراک باقی مانده خود را ببینم",
    answer: ` - از طریق سایت :
    وارد بخش پروفایل شده و از طریق بخش جزییات اشتراک مدت زمان باقی مانده از اشتراک را بررسی کنید. 
    - از طریق اپ :
    وارد بخش تنظیمات شوید و از بخش اشتراک ها، مدت زمان باقی مانده از اشتراک را بررسی نمایید .`
  },
  {
    question: " آیا می‌شود بیشتر از یک بسته اشتراک خرید؟",
    answer:
      "شما میتوانید بدون محدودیت زمان اشتراک خرید‌داری کنید در واقع اشتراک خریداری شده به پایان اشتراک قبلی اضافه میشود و مجموعه اشتراک‌های خریداری شده با هم جمع می‌شوند.   برای مثال: اگر شما اشتراک 3 ماهه دارید، با خرید یک اشتراک یک ماهه در مجموع زمان اشتراک شما به 4 ماه تغییر میابد."
  },
  {
    question: "اشتراک خریدم، مبلغ از حسابم کم شده ولی اشتراک فعال نشده‌است",
    answer: `اشتراک خریداری شده روی آدرس ایمیل و یا شماره موبایل شما ذخیره میشود و قابل استفاده است
    لطفا مراحل زیر را بررسی فرمایید
    1. وارد بخش پروفایل در اپلیکیشن و یا وب سایت دیجیتون شوید 
    2. چک کنید که همان شماره موبایل یا ایمیلی که با آن اقدام به خرید اشتراک کرده اید در این قسمت درج شده است 
    3. در صورتی که شماره موبایل یا ایمیل دیگری در این قسمت بود، از بخش تنظیمات از حساب کاربری خود خارج شده و مجددا با شماره و یا ایمیل دارای اشتراک وارد شوید.
    اگر شماره حساب کاربری دیجیتون و شماره ای که با آن اشتراک تهیه کردید یکسان بود و مبلغ از حساب شما کم شده، اما اشتراک فعال نشده‌است، طبق اطلاعیه بانک مرکزی نهایتا تا 72 ساعت کاری مبلغ از سمت بانک به حساب شما بازگشت داده میشود. 
    اگر مبلغ به حساب شما بازنگشت، مشکل خود را با تیم پشتیبانی دیجیتون در میان بگذارید.`
  },
  {
    question: "نحوه استفاده از کد تخفیف وکد هدیه",
    answer: `کد هدیه و یا کد تخفیف خود را در سایت از بخش (پروفایل-->کد هدیه) یا در اپلیکیشن از بخش (تنظیمات --> کد هدیه) وارد بفرمایید.  توجه داشته باشید که هر کد هدیه فقط یکبار قابل استفاده است .`
  }
];
